import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";
import "./TestMarksPrint.css";


const getAuthToken = () => localStorage.getItem("authToken");

const TestMarksReport = () => {
    const navigate = useNavigate();
  const { testId } = useParams();
  const [testInfo, setTestInfo] = useState(null);
  const [marks, setMarks] = useState([]);
  const printRef = useRef();

  useEffect(() => {
    fetchTestMarks();
  }, [testId]);

  const fetchTestMarks = async () => {
    try {
      const res = await axios.get(
        `${appConstants.API_ROOT_URL}get-test-marks?test_id=${testId}`,
        {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        }
      );
      if (res.data.status === "success") {
        setTestInfo(res.data.test_info);
        setMarks(res.data.students); // ✅ this is the correct field
      }
    } catch (error) {
      console.error("Failed to fetch test marks", error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Layout>
        <div className="text-end mt-1">
            <Button onClick={handleBack} variant="secondary" className="me-1">
                Back
            </Button>
          <Button onClick={handlePrint} variant="primary">
            Print / Save as PDF
          </Button>
        </div>

              
      <div className="container mt-1" ref={printRef}>
        {testInfo && (
          <>
            <h4 className="mb-1">{testInfo.test_name}</h4>
            <p className="text-muted mb-2">
              Date: {testInfo.exam_date} | Subject: {testInfo.subject_name} | Type:{" "}
              {testInfo.test_type} | Total Mark: {testInfo.total_mark}
            </p>
          </>
        )}

<div className="table-responsive">
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Student Name</th>
              <th>Mark</th>
            </tr>
          </thead>
          <tbody>
            {marks.map((student, index) => (
              <tr key={student.student_id}>
                <td>{index + 1}</td>
                <td>{student.name}</td>
                <td>{student.mark !== null ? student.mark : ""}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        
      </div>
      </div>
    </Layout>
  );
};

export default TestMarksReport;
